<template lang='pug'>
  .fpui-layout(:class="getClasses()")
    slot
</template>

<script>
export default {
  props: {
    orientation: String
  },
  methods: {
    getClasses () {
      if (this.orientation === 'vertical') {
        return 'fpui-layout-vertical'
      }
      return 'fpui-layout-horizontal'
    }
  }
}
</script>

<style lang='less'>
  @import '~@/shared/styles/_variables.less';
  .fpui-layout {
    display: flex;
    height:100%;
    .head {
      text-transform: uppercase;
      height:40px;
    }
    .body {
      height:calc(~"100% - 40px");
    }
  }
  .fpui-layout-resizer {
    position: relative;
    &:before {
      content:"";
      position: absolute;
      background:#eff0ef;
    }
    &:hover {
      &:before {
        background:@blue;
      }
    }
  }

  .head {
    font-weight:200;
    line-height: 40px;
    font-size:20px;
    padding-left:30px;
    text-transform: uppercase;
    font-family: 'Josefin Sans';
  }

  .collapse {
    .body {
      display: none;
    }
  }

  .collapse-horizontal-next {
    .head {
      transform:rotate(90deg);
      transform-origin:27px 4px;
    }
  }

  .collapse-horizontal-prev {
    .head {
      transform:rotate(-90deg);
      transform-origin:62px 60px;
    }
  }

  .fpui-layout-horizontal {
    .fpui-layout-resizer {
      width:16px;
      height:100%;
      &:before {
        width:3px;
        height:100%;
        left:50%;
        top:0;
        transform:translateX(-50%);
      }
    }
  }
  .fpui-layout-vertical {
    flex-direction: column;
    .fpui-layout-resizer {
      height:16px;
      width:100%;
      &:before {
        height:3px;
        width:100%;
        left:0;
        top:50%;
        transform:translateY(-50%);
      }
    }
  }
</style>
